import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Delivery } from 'src/app/models/delivery.schema';
import { Partner } from 'src/app/models/partner.schema';
import { UserService } from 'src/app/services/user.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ServiceModel } from 'src/app/models/service.schems';
import { Service } from 'src/app/services/service.service';
import { PartnerInvoiceService } from 'src/app/services/partner-invoice.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { DeliveryService } from 'src/app/services/delivery.service';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { getItalianMonthName } from 'src/app/helpers/italian-month.helper';
import { DatePipe } from '@angular/common';
import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Product } from 'src/app/models/product.schema';

@Component({
  selector: 'app-partner-invoice-form',
  templateUrl: './partner-invoice-form.component.html',
  styleUrls: ['./partner-invoice-form.component.scss']
})
export class PartnerInvoiceFormComponent implements OnInit {
  
  @ViewChild('htmlPdf') htmlPdfRef!: ElementRef;
  public deliveries: Delivery[] = [];
  public partner: Partner;
  public user: any;
  public TotalAmount: any = 0;
  public totalToPay: any = 0;
  public totalToReceive: any = 0;
  currentDate: Date = new Date();
  public services: ServiceModel[] = [];
  public totalWorkingHours: any = 0;
  public totalPrice: any = 0;
  public totalPlusPrice: any = 0;
  public totalProductValue: any = 0;
  public totalValue: any = 0;
  public totalValuePlusVat: any = 0;
  public totalToRecieve: any = 0;
  public totalToRecieveAmount: any = 0;
  public totalToPayAmount: any = 0;
  public lastTotal: any = 0;
  public disableBtn: boolean = false;
  public historyPage: string = "";
  groups: any;
  fromDate: any;
  toDate: any;
  newTotalAmount: number = 0;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      deliveries: Delivery[],
      partner: Partner,
      historyPage: any,
      fromDate: any,
      toDate: any,
    },
    private partnerInvoiceService: PartnerInvoiceService,
    private userService: UserService,
    private dialogRef: MatDialogRef<PartnerInvoiceFormComponent>,
    public service: Service,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private deliveryService: DeliveryService,
    private authStatusService: AuthStatusService,
    private commanUsesService: CommanUsesService,
  ) {
    (pdfMake as any).vfs = pdfFonts.vfs;
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    this.historyPage = data.historyPage;
    this.deliveries = data.deliveries;
    this.partner = data.partner;
    this.fromDate = data.fromDate ? new DatePipe('it-IT').transform(new Date(data.fromDate), 'dd-MM-yyyy') : '';
    this.toDate = data.toDate ? new DatePipe('it-IT').transform(new Date(data.toDate), 'dd-MM-yyyy') : '';
    this.calculateTotalPayAndReceive();
    this.calculateTotals();
  }

  async ngOnInit() {
    this.user = await this.userService.getMyInformation();
    await this.getAllService();
  }

  async getAllService(){
    try {
      const services = await this.service.getAllServicess();
      this.services = services.services;
    }
    catch { }
  }

  showServiceDetails(serviceId: number){
    if(serviceId){
      const service = this.partner?.partnerServices.find((item) => {
        return item?.service?.id == serviceId;
      });
      return service;
    }
  }

  calculateTotalPayAndReceive(){
    this.deliveries.forEach((delivery: any) => {
      if(delivery?.billable){
        let serviceDetails = this.showServiceDetails(Number(delivery?.service));
        if(serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL){
          this.totalToRecieveAmount += this.calculateTotalForSales(delivery);
        }
        if(
          serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL ||
          serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL ||
          serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL
        ){
          let value: any = (delivery?.price) + (delivery?.additionalPrice);
          let valuePlusVat: any = value + (value * 22)/100;
          this.totalToPayAmount += valuePlusVat;
        }
        if(serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL){
          let value: any = (delivery?.price) + (delivery?.additionalPrice);
          let valuePlusVat: any = value + (value * 22)/100;
          this.totalToPayAmount += valuePlusVat;
        }
      }
    });
  }

  showValuePrice(delivery: any){
    // if(delivery.deliveryWithoutCommision) return 0;
    let res = Number(delivery?.price) + (delivery?.additionalPrice ? Number(delivery?.additionalPrice) : 0);
    return res.toFixed(2);
  }

  showValuePlusVat(delivery: any){
    if(delivery?.serviceType?.toLowerCase() === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL) {
      // if(delivery.deliveryWithoutCommision) return 0;
      let finalPrice: number = 0;
      finalPrice = (Number(delivery?.price) || 0) + (Number(delivery?.price) * 22) / 100;
      return finalPrice.toFixed(2);
    } else if(delivery.serviceType?.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL){
      let value = delivery?.price + (delivery?.additionalPrice ? delivery?.additionalPrice : 0);
      let res = value + parseFloat(delivery?.deliveryProducts[0].price);
      return res?.toFixed(2);
    } else {
      let value = delivery?.price + (delivery?.additionalPrice ? delivery?.additionalPrice : 0);
      let valuePlusVat = value + (value * 22)/100;
      return valuePlusVat?.toFixed(2);
    }
  }

  showTotalForSales(delivery: any){
    if(delivery?.billable) {
      let pricePlusVat = (Number(delivery?.price) || 0) + (Number(delivery?.price) * 22) / 100;
      let valueMinusPriceVat = Number(delivery?.productValue) - Number(pricePlusVat);
      let finalPrice: number = 0;
      finalPrice = (Number(valueMinusPriceVat) + Number(delivery?.additionalPrice));
      // finalPrice = delivery.deliveryWithoutCommision ? (Number(delivery?.productValue)) : (Number(valueMinusPriceVat) + Number(delivery?.additionalPrice));
      return finalPrice.toFixed(2);
    } else {
      return "0.00 €";
    }
  }

  calculateTotalForSales(delivery: Delivery){
    if(delivery?.billable) {
      let price = this.commonFunctionForValues(delivery).prezzo;
      let pricePlusVat = price + price * 22 / 100;
      let productValue = this.commonFunctionForValues(delivery).valoreProdotto;
      let valueMinusPriceVat = productValue - pricePlusVat;
      const lastValue = valueMinusPriceVat + delivery.additionalPrice || 0
      return lastValue;

      /* Old Calculations 
      let pricePlusVat = (Number(delivery?.price) || 0) + (Number(delivery?.price) * 22) / 100;
      let valueMinusPriceVat = Number(delivery?.productValue) - Number(pricePlusVat);
      return Number(valueMinusPriceVat) + (Number(delivery?.additionalPrice));
      Old Calculations */ 
    } else {
      return "0.00 €";
    }
  }

  calculateTotals(){
    if(this.deliveries.length){
      this.deliveries.forEach((delivery: any) => {

        this.totalWorkingHours  += parseFloat(delivery?.hours ? delivery?.hours : 0);
        this.totalPrice         += this.commonFunctionForValues(delivery).prezzo;
        this.totalPlusPrice     += this.commonFunctionForValues(delivery).plusMinusPrezzo;
        this.totalProductValue  += this.commonFunctionForValues(delivery).valoreProdotto;
        this.totalValue         += this.commonFunctionForValues(delivery).valore;
        this.totalValuePlusVat  += this.commonFunctionForValues(delivery).valoreIva;
        this.lastTotal          += this.commonFunctionForValues(delivery).totale;

        /* Old Calculations
        if(delivery?.billable){
          let serviceDetails = this.showServiceDetails(Number(delivery?.service));
          this.totalWorkingHours += parseFloat(delivery?.hours ? delivery?.hours : 0);
          this.totalPrice += parseFloat(delivery?.price ? delivery?.price : 0);
          // this.totalPrice += delivery.deliveryWithoutCommision ? 0 : parseFloat(delivery?.price ? delivery?.price : 0);
          this.totalPlusPrice += parseFloat(delivery?.additionalPrice ? delivery?.additionalPrice : 0);
          this.totalProductValue += delivery?.serviceType?.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL ? delivery?.deliveryProducts[0].price ? parseFloat(delivery?.deliveryProducts[0].price) : 0 : parseFloat(delivery?.productValue ? delivery?.productValue : 0);
          this.totalValue += delivery?.price + (delivery?.additionalPrice ? delivery?.additionalPrice : 0);
          // this.totalValue += delivery.deliveryWithoutCommision ? 0 : delivery?.price + (delivery?.additionalPrice ? delivery?.additionalPrice : 0);
          let value = (delivery?.price + (delivery?.additionalPrice ? delivery?.additionalPrice : 0));
          let valuePlusVat = value + (value * 22)/100;
          this.totalValuePlusVat += (serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL ? (value += parseFloat(delivery?.deliveryProducts[0].price) ) : valuePlusVat);
          // this.totalValuePlusVat += delivery.deliveryWithoutCommision ? 0 : (serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL ? (value += parseFloat(delivery?.deliveryProducts[0].price) ) : valuePlusVat);
          if(
            serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL || 
            serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL || 
            serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL
          ){
            let value = (delivery?.price) + (delivery?.additionalPrice);
            let valuePlusVat = value + (value * 22)/100;
            this.lastTotal += valuePlusVat;
          } 
          if(serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL){
            let value = (delivery?.price) + (delivery?.additionalPrice);
            this.lastTotal += (value + parseFloat(delivery?.deliveryProducts[0].price));
          } 
          if(serviceDetails?.service?.pricingModel.toLowerCase() === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL){
            this.lastTotal += this.calculateTotalForSales(delivery);
          }
        }
        Old Calculations */
      });
    }
  }

  async downloadInvoice() {
    await this.generatePdfNew('download');
  }

  async viewInvoice() {
    // this.generateHtmlContent();
    await this.generatePdfNew('open');
  }

  async sendInvoice() {
    await this.generatePdfNew('blob');
  }
  
  generatePdf(action: string) {
    const DATA: any = this.htmlPdfRef.nativeElement;
    html2canvas(DATA).then((canvas) => {
      const pdfHeight = 297;
      const fileWidth = 208;
      const fileHeight = (canvas.height * fileWidth) / canvas.width;
      const totalPages = Math.ceil(fileHeight / pdfHeight);
      let PDF = new jsPDF('p', 'mm', 'a4');
      for (let i = 0; i < totalPages; i++) {
        if (i > 0) {
          PDF.addPage();
        }
        let position = -i * pdfHeight;
        PDF.addImage(
          canvas.toDataURL('image/png'),
          'PNG',
          0,
          position,
          fileWidth,
          fileHeight
        );
      }

      switch(action) {
        case 'download':
          PDF.save('partner-invoice.pdf');
          break;
        case 'view':
          const pdfUrl = URL.createObjectURL(PDF.output('blob'));
          const newWindow = window.open('', '_blank');
          if (newWindow) {
            newWindow.location.href = pdfUrl;
          }
          break;
        /*
        case 'send':
          this.disableBtn = true;
          const pdfBlob = PDF.output('blob');
          const formData = new FormData();
          formData.append('invoice', pdfBlob, 'partner-invoice.pdf');
          formData.append('deliveries', JSON.stringify(this.deliveries));
          let promise = this.partnerInvoiceService.sendInvoiceToPartner(formData, this.partner?.id);
          promise.then((res: any)=> {
            if(res){
              this.disableBtn = false;
              this.openSnackBar('Fattura inviata con successo');
              this.dialogRef.close({ success: true });
              this.deliveries = [];
              this.TotalAmount = 0;
            }
          }).catch((err: any)=> {
            this.disableBtn = false;
            this.openSnackBar(`${err.error.message}`);
          })
          break;
        */
        default:
          break;
      }
    });
  }


  openSnackBar(message: string) {
    this._snackBar.open(`${message}`, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    })
  }

  async exportInvoiceInfo(){
    let res = await this.deliveryService.exportInvoiceInfo(this.deliveries);
    let anchor = document.createElement('a');
    anchor.download = 'pro_forma_partner.xlsx';
    anchor.href = (window.webkitURL || window.URL).createObjectURL(res.body);
    anchor.dataset.downloadurl = [res.body.type, anchor.download, anchor.href].join(':');
    anchor.click();
  }

  async generatePdfNew(mode: 'open' | 'print' | 'download' | 'dataurl' | 'base64' | 'blob' = 'open') {

    try {
      this.disableBtn = true;
      const documentDefinition = await this.generatePartnerPDF();
      const pdf = pdfMake.createPdf(documentDefinition);
      switch (mode) {
        case 'open':
          pdf.open();
          this.disableBtn = false;
          break;
        case 'print':
          pdf.print();
          this.disableBtn = false;
          break;
        case 'download':
          pdf.download('partner-invoice.pdf');
          this.disableBtn = false;
          break;
        case 'dataurl':
          pdf.getDataUrl((dataUrl) => {
            console.log('Data URL:', dataUrl);
          });
          this.disableBtn = false;
          break;
        case 'base64':
          pdf.getBase64((data) => {
            console.log('Base64:', data);
          });
          this.disableBtn = false;
          break;
        case 'blob':
          pdf.getBlob(async (pdfBlob: Blob) => {
            const formData = new FormData();
            formData.append('invoice', pdfBlob, 'partner-invoice.pdf');
            const deliveryIds = this.deliveries.map(d => d.id);
            formData.append('deliveries', JSON.stringify(deliveryIds));
            formData.append('emailBody', this.generateHtmlContent());
            formData.append('totalAmount', this.newTotalAmount?.toFixed(2));
            let promise = this.partnerInvoiceService.sendInvoiceToPartner(formData, this.partner?.id);
            promise.then((res) => {
              this.disableBtn = false;
              this.dialogRef.close({ success: true });
              this.deliveries = [];
              this.TotalAmount = 0;
            }).catch((error) => {
              let errorMsg = '';
              if(error.error.message === 'PARTNER_NON_HA_EMAIL_DI_FATTURAZIONE' && error.error.statusCode === '404') {
                errorMsg = 'PARTNER_NON_HA_EMAIL_DI_FATTURAZIONE';
              } else {
                errorMsg = error.error.message;
              }
              this.commanUsesService.showSnackBar(errorMsg);
              this.disableBtn = false;
            })
          });
          break;
      }
    } catch (error) {
      this.disableBtn = false;
    }
    /*
    switch (action) {
      case 'open': pdfMake.createPdf(documentDefinition).open(); break;
      case 'print': pdfMake.createPdf(documentDefinition).print(); break;
      default: pdfMake.createPdf(documentDefinition).open(); break;
    }
    */
  }

  async uploadOnFatture() {
    if (this.disableBtn) {
      return;
    }

    try {
      this.disableBtn = true;

      if (!this.partner?.id) {
        this.commanUsesService.showSnackBar('Partner not found');
        return;
      }

      const deliveryIds = this.deliveries
        .map(delivery => Number(delivery.id))
        .filter(id => Number.isInteger(id) && id > 0);

      if (!deliveryIds.length) {
        this.commanUsesService.showSnackBar('No deliveries selected');
        return;
      }

      const payload = {
        deliveries: deliveryIds,
      };

      const response = await this.partnerInvoiceService.uploadPartnerInvoiceOnFattureCloud(
        payload,
        Number(this.partner.id),
      );

      this.commanUsesService.showSnackBar(
        response?.message || 'Invoice uploaded on fatture cloud',
      );
      this.dialogRef.close({ success: true });
    } catch (error) {
      const errorMessage = this.getApiErrorMessage(error);
      this.commanUsesService.showSnackBar(errorMessage);
    } finally {
      this.disableBtn = false;
    }
  }

  private getApiErrorMessage(error: any): string {
    const apiError = error?.error;

    const message =
      apiError?.message ||
      apiError?.error_description ||
      apiError?.details ||
      error?.message ||
      'Something went wrong';

    if (Array.isArray(message)) {
      return message.join(', ');
    }

    if (typeof message === 'object') {
      return (
        message?.message ||
        message?.error_description ||
        message?.error ||
        JSON.stringify(message)
      );
    }

    return message;
  }

  generateHtmlContent() {

    let totalProductValue: any = 0;
    let salesCommision: any = 0;
    let totalSalesPrice: any = 0;
    let totalFixedHourlyPrice: any = 0;
    let isSaleTypeDeliveries: boolean = false;

    const billableDeliveries = this.deliveries.filter(delivery => delivery?.billable);

    billableDeliveries.forEach((delivery: Delivery) => {
    
      const serviceDetails = this.showServiceDetails(Number(delivery?.service));
      const pricingModel = serviceDetails?.service?.pricingModel?.toLowerCase();
      const deliveryPrice = Number(delivery.price) || 0;
      const additionalPrice = Number(delivery.additionalPrice) || 0;
    
      if ([APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL, APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL].includes(pricingModel)) {
        const total = deliveryPrice + additionalPrice;
        totalFixedHourlyPrice += total + (total * 0.22);
      }
    
      if (pricingModel === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL) {
        isSaleTypeDeliveries = true;    
        totalProductValue += Number(delivery.productValue);
        salesCommision += Number(this.showValuePlusVat(delivery) || 0);
        totalSalesPrice += Number(this.showTotalForSales(delivery) || 0);
      }
    });

    /*
    console.log("Vendite Totali:", totalProductValue.toFixed(2));
    console.log("Nostri Commissioni + Iva:", salesCommision.toFixed(2));
    console.log("Totale Dovuto Vendite:", totalSalesPrice.toFixed(2));
    */

    let html = `
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
        <h2 style="text-align: center; color: #000;">Dettaglio Fatturazione</h2>
        <p>Buongiorno,</p>
        <p>Nella speranza che questa mail vi trovi bene, abbiamo il piacere di inviarvi in allegato il dettaglio corretto delle vendite e dei servizi dal <strong>${this.fromDate ? this.fromDate : '---'}</strong> al <strong>${this.toDate ? this.toDate : "---"}</strong> con proforma per la fatturazione.</p>
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0;">
          <tbody>
    `;

    if (isSaleTypeDeliveries) {
      html += `
        <tr>
          <td style="padding: 6px 0;"><strong>Vendite Totali:</strong></td>
          <td style="text-align: right;">€ ${totalProductValue.toFixed(2)}</td>
        </tr>
        <tr>
          <td style="padding: 6px 0;"><strong>Nostre Commessioni (iva inclusa):</strong></td>
          <td style="text-align: right;">€ ${salesCommision.toFixed(2)}</td>
        </tr>
        <tr>
          <td style="padding: 6px 0;"><strong>Totale Dovuto Vendite:</strong></td>
          <td style="text-align: right;">€ ${totalSalesPrice.toFixed(2)}</td>
        </tr>
      `;
    }

    html += `
      <tr>
        <td style="padding: 6px 0;"><strong>Totale Servizi da Pagare (Iva Inclusa)::</strong></td>
        <td style="text-align: right;">€ ${totalFixedHourlyPrice.toFixed(2)}</td>
      </tr>
    `;

    if (totalSalesPrice > totalFixedHourlyPrice) {
      html += `
        <tr>
          <td style="padding: 6px 0; color: green;"><strong>Vostro Credito:</strong></td>
          <td style="text-align: right; color: green;">€ ${(totalSalesPrice - totalFixedHourlyPrice).toFixed(2)}</td>
        </tr>
      `;
    } else if ((totalSalesPrice) < totalFixedHourlyPrice) {
      html += `
        <tr>
          <td style="padding: 6px 0; color: red;"><strong>Vostro Debito:</strong></td>
          <td style="text-align: right; color: red;">€ ${(totalSalesPrice - salesCommision).toFixed(2)}</td>
        </tr>
      `;
    }

    html += `
          </tbody>
        </table>
        <p>Rimaniamo a completa disposizione.</p>
        <p>Cordialmente,<br><br><strong>Amministrazione Deluxy</strong></p>
      </div>
    `;

    return html;
  }

  async generatePartnerPDF() {

    try {
  
      let totals = {
        productValue: 0,
        price: 0,
        additionalPrice: 0,
        value: 0,
        valuePlusVat: 0,
        total: 0,
        totalToPay: 0,
        totalToReceive: 0
      };

      const billableDeliveries = this.deliveries.filter(delivery => delivery?.billable);
  
      const bodyRows = billableDeliveries.map((delivery: Delivery) => {

        const serviceDetails = this.showServiceDetails(Number(delivery?.service));
        const service = serviceDetails?.service || {};
        const pricingModel = service?.pricingModel?.toLowerCase();
        const price = Number(delivery?.price || 0);
        // const price = delivery.deliveryWithoutCommision ? 0 : Number(delivery?.price || 0);
        const additionalPrice = Number(delivery?.additionalPrice || 0);
        const priceAndPlusPrice = price + additionalPrice;
        const isFixedOrHourly = [APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL, APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL].includes(pricingModel);
        const isCorporate = pricingModel === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL;
        const isSales = pricingModel === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL;
        const firstProduct = delivery?.deliveryProducts?.[0];
        const productPrice = firstProduct ? Number(firstProduct.price || 0) : 0;

        const productValue = isCorporate
          ? productPrice
          : Number(delivery?.productValue || 0);
        const value = this.showValuePrice(delivery);
        const valuePlusVat = isCorporate
          ? priceAndPlusPrice + productPrice
          : priceAndPlusPrice + priceAndPlusPrice * 0.22;
        // const valuePlusVat = delivery.deliveryWithoutCommision ? 0 : isCorporate
        //   ? priceAndPlusPrice + productPrice
        //   : priceAndPlusPrice + priceAndPlusPrice * 0.22;
        const total = isFixedOrHourly
          ? priceAndPlusPrice + priceAndPlusPrice * 0.22
          : isCorporate
          ? priceAndPlusPrice + productPrice
          : isSales
          ? this.calculateTotalForSales(delivery)
          : 0;
  
        totals.price += price;
        totals.additionalPrice += additionalPrice;
        totals.productValue += productValue;
        totals.value += Number(value);
        totals.valuePlusVat += Number(valuePlusVat);
        totals.total += Number(total);

        if(isSales){
          totals.totalToReceive += Number(this.calculateTotalForSales(delivery));
        }
        if(isFixedOrHourly){
          let value: any = (delivery?.price) + (delivery?.additionalPrice);
          let valuePlusVat: any = value + (value * 22)/100;
          totals.totalToPay += valuePlusVat;
        }
        if(isCorporate){
          let value: any = (delivery?.price) + (delivery?.additionalPrice);
          totals.totalToPay += value + productPrice;
        }
  
        this.newTotalAmount = totals.totalToPay;
        return [
          "#" + delivery.id,
          delivery.address,
          delivery?.billable ? "YES" : "NO",
          new Date(delivery.deliveryDate).toLocaleDateString('it-IT'),
          this.formatProductInfo(delivery),
          service?.serviceName?.toUpperCase() || "---",
          pricingModel === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL
            ? "Servizi a Prezzo Fisso"
            : pricingModel === APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL
            ? "Servizi a Ora"
            : pricingModel === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL
            ? "Vendita"
            : pricingModel === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL
            ? "Corporate Servizi"
            : "",
          delivery.notes || "---",
          delivery.distance || "0",
          delivery.hours || "0",
          Number(productValue).toFixed(2) + "€",
          pricingModel === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL ? serviceDetails?.price + "%" : "---",
          // pricingModel === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL ? delivery.deliveryWithoutCommision ? 0 : serviceDetails?.price + "%" : "---",
          Number(price).toFixed(2) + "€",
          Number(additionalPrice).toFixed(2) + "€",
          Number(value).toFixed(2) + "€",
          Number(valuePlusVat).toFixed(2) + "€",
          Number(total).toFixed(2) + "€",
        ];
      });
  
      const docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [20, 30, 20, 30],
        content: [
          {
            columns: [
              [
                { text: 'Fattura', style: 'topTitle' },
                { text: `From: Amministrazione Deluxy`, margin: [0, 10, 0, 0], style: 'topText'  },
                { text: `${this.user?.complainEmail || '---'}`, style: 'topText' },
                // { text: 'Website: Deluxy', style: 'topText', link: 'https://deluxy.it', color: '#0000EE' },
              ],
              [
                {
                  alignment: 'right',
                  stack: [
                    { text: `Date: ${new Date().toLocaleString('it-IT')}`, style: 'topText' },
                    { text: `To: ${this.partner?.agency}`, bold: true, margin: [0, 10, 0, 0], style: 'topText' },
                    { text: `Partita Iva: ${this.partner?.vatCode}`, style: 'topText' },
                    { text: `${this.partner?.address || ''}`, style: 'topText' },
                    { text: `${this.partner?.phone || ''}`, style: 'topText' },
                    { text: `${this.partner?.user?.email || ''}`, style: 'topText' },
                  ],
                },
              ],
            ],
            columnGap: 30,
            margin: [0, 0, 0, 20],
          },
    
          {
            table: {
              headerRows: 1,
              widths: [
                'auto', // ID
                'auto', // INFO
                50,     // DA FATTURARE
                45,     // DATA
                'auto', // PRODOTTO
                55,     // NOME SERVIZIO
                55,     // TIPO SERVIZIO
                70,     // NOTE
                30,     // DISTANZA
                'auto', // ORE
                45,     // VALORE PRODOTTO
                'auto', // FEE
                45,     // PREZZO
                30,     // +/- PREZZO
                30,     // VALORE
                30,     // VALORE+IVA
                30      // TOTALE
              ],  
              body: [
                [
                  { text: 'ID CONSEGNA ', style: 'tableHeader' },
                  { text: 'INDIRIZZO', style: 'tableHeader' },
                  { text: 'DA FATTURARE', style: 'tableHeader' },
                  { text: 'DATA', style: 'tableHeader' },
                  { text: 'PRODOTTO', style: 'tableHeader' },
                  { text: 'NOME SERVIZIO', style: 'tableHeader' },
                  { text: 'TIPO SERVIZIO', style: 'tableHeader' },
                  { text: 'NOTE', style: 'tableHeader' },
                  { text: 'DISTANZA', style: 'tableHeader' },
                  { text: 'ORE', style: 'tableHeader' },
                  { text: 'VALORE PRODOTTO', style: 'tableHeader' },
                  { text: 'FEE', style: 'tableHeader' },
                  { text: 'PREZZO', style: 'tableHeader' },
                  { text: '+/- PREZZO', style: 'tableHeader' },
                  { text: 'VALORE', style: 'tableHeader' },
                  { text: 'VALORE+IVA', style: 'tableHeader' },
                  { text: 'TOTALE', style: 'tableHeader' },
                ],
                ...bodyRows,
                [
                  { text: 'TOTALE', colSpan: 10, alignment: 'right', bold: true }, {}, {}, {}, {}, {}, {}, {}, {}, {},
                  { text: totals.productValue.toFixed(2) + '€', bold: true },
                  '', // fee is %
                  { text: totals.price.toFixed(2) + '€', bold: true },
                  { text: totals.additionalPrice.toFixed(2) + '€', bold: true },
                  { text: totals.value.toFixed(2) + '€', bold: true },
                  { text: totals.valuePlusVat.toFixed(2) + '€', bold: true },
                  { text: totals.total.toFixed(2) + '€', bold: true },
                ]
              ],
            },
            layout: {
              fillColor: (rowIndex: number) =>
                rowIndex === 0 ? '#c2b55f' : rowIndex % 2 === 0 ? '#f7f7f7' : null,
              hLineColor: () => '#ccc',
              vLineColor: () => '#ccc',
              paddingLeft: () => 3,
              paddingRight: () => 3,
              paddingTop: () => 3,
              paddingBottom: () => 3,
            },
          },
          {
            margin: [0, 30, 0, 0],
            columns: [
              {
                width: '*',
                text: 'TOTALE DA PAGARE : SUM OF SERVIZIO PREZZO (FIXED/HOURLY + PLUS PREZZO) + VAT (22% of fee) :',
                fontSize: 10,
                bold: true,
                alignment: 'right',
                margin: [0, 0, 5, 0], 
              },
              {
                width: 80,
                text: totals.totalToPay.toFixed(2) + '€',
                fontSize: 10,
                bold: true,
                alignment: 'right',
              }
            ],
          },
          {
            columns: [
              {
                width: '*',
                text: 'TOTALE DA INCASSARE: PRODOTTO VALUE - (Fee% + Fee% * Vat[22%]) :',
                fontSize: 10,
                bold: true,
                alignment: 'right',
                margin: [0, 0, 5, 0],
              },
              {
                width: 80,
                text: totals.totalToReceive.toFixed(2) + '€',
                fontSize: 10,
                bold: true,
                alignment: 'right',
              }
            ],
            margin: [0, 5, 0, 0],
          }
        ],
    
        styles: {
          tableHeader: {
            bold: true,
            fontSize: 8,
            color: 'white',
            alignment: 'center',
          },
          topTitle: {
            color: '#c2b55f',
            fontSize: 18,
            bold: true,
            marginBottom: 10,
          },
          topText: {
            fontSize: 9,
          }
        },
    
        defaultStyle: {
          fontSize: 7,
        },
    
        /*
        info: {
          title: 'Attivita_Valet_Report',
          author: 'Deluxy',
          subject: 'Report Attività Mensile',
        },
        */
      };
      return docDefinition;
    } catch (error) {
      console.log("eroor", error)
    }
  }
  
  formatProductInfo = (delivery: any) => {
    if (delivery?.deliveryProducts && delivery.deliveryProducts.length > 0) {
      return delivery.deliveryProducts
        .map((dProduct: any, index: number, array: any[]) => {
          const productInfo = `${dProduct?.product ? dProduct?.product?.name : ''} - ${dProduct?.productVariant ? dProduct?.productVariant?.variantName : ""}`;
          return index !== array.length - 1 ? productInfo + ', ' : productInfo;
        })
        .join('');
    }
    return '';
  };
  

  commonFunctionForValues(delivery: Delivery) {
    let totals = {
      totalWorkingHours: 0,
      valoreProdotto: 0,
      fee: 0,
      prezzo: 0,
      plusMinusPrezzo: 0,
      valore: 0,
      valoreIva: 0,
      totale: 0
    };

    if(!delivery?.billable){
      return totals;
    }

    let serviceDetails = this.showServiceDetails(Number(delivery?.service));
    let pricingModel = serviceDetails?.service?.pricingModel?.toLowerCase() || '';

    const IS_SALE_SERVICE = pricingModel === APP_CONSTANTS.SALE_SERVICE_INVOICE_MODEL;
    const IS_CORPORATE_SERVICE = pricingModel === APP_CONSTANTS.CORPORATE_SERVICE_INVOICE_MODEL;
    const IS_FIXED_PRICE_SERVICE = pricingModel === APP_CONSTANTS.FIXED_SERVICE_INVOICE_MODEL;
    const IS_HOURLY_RATE_SERVICE = pricingModel === APP_CONSTANTS.HOURLY_SERVICE_INVOICE_MODEL;
    const IS_WAREHOUSE_SERVICE = pricingModel === APP_CONSTANTS.WAREHOUSE_SERVICE_INVOICE_MODEL;

    
    const VAT = 0.22;
    // Base assignments
    totals.valoreProdotto = Number(delivery?.productValue) || 0;
    totals.fee = Number(serviceDetails?.price) || 0;
    totals.plusMinusPrezzo = Number(delivery?.additionalPrice) || 0;

    if (IS_SALE_SERVICE) {
      totals.valoreProdotto = Number(delivery?.productValue) || 0;
      totals.fee = Number(serviceDetails?.price) || 0;

      let TotalSelectedProPrice = delivery.deliveryProducts
        ?.map(item => {
          if (item.deliveryWithoutCommision) return 0;

          const product: Product = item.product;
          const productVariant = item?.productVariant || null;
          let quantity = item?.quantity || 1;
          let price = product?.price ? Number(product.price) : 0;

          if (delivery.isFlexiblePrice && delivery.flexiblePrice) {
            try {
              const flexibleData = JSON.parse(delivery.flexiblePrice);

              const productData = flexibleData.find(
                (flexData) => flexData?.product?.id === product?.id
              );

              if (productData?.flexiblePrice != null) {
                price = Number(productData.flexiblePrice);
              }
            } catch (e) {
              console.error("Invalid flexiblePrice JSON");
            }
          } else if (productVariant) {
            price = Number(productVariant.variantPrice);
          }

          if (!isNaN(price) && !isNaN(quantity)) {
            return price * quantity;
          }

          return 0; 
        })
        .reduce((acc, curr) => acc + curr, 0);

      if (delivery.id == 55186) {
        console.log("serviceDetails", serviceDetails);
        console.log("TotalSelectedProPrice", TotalSelectedProPrice);
        console.log(
          "Commission",
          (TotalSelectedProPrice * Number(serviceDetails?.price)) / 100
        );
      }

      // let price = (TotalSelectedProPrice * Number(serviceDetails?.price)) / 100;
      // let price = (Number(delivery?.productValue || 0) * Number(serviceDetails?.price)) / 100;
      let price = Number(delivery?.price);

      totals.prezzo = price || 0;
      totals.valore = totals.prezzo + totals.plusMinusPrezzo;
      totals.valoreIva = totals.prezzo + totals.valore * 0.22;
      let pricePlusVat = price + (price * 0.22);
      let valueMinusPriceVat = (Number(delivery?.productValue) || 0) - pricePlusVat;
      totals.totale = valueMinusPriceVat + (Number(delivery?.additionalPrice) || 0);
      return totals;
    }

    // =========================
    // DEFAULT FLOW
    // =========================
    totals.prezzo = Number(delivery?.price) || 0;
    totals.valore = totals.prezzo + totals.plusMinusPrezzo;
    totals.valoreIva = totals.valore * VAT;

    // ===========================
    // Fixed / Hourly / Warehouse
    // ===========================
    if (IS_FIXED_PRICE_SERVICE || IS_HOURLY_RATE_SERVICE || IS_WAREHOUSE_SERVICE) {
      const value = totals.valore;
      totals.totale = value + (value * VAT);
    }

    // ===========================
    // Corporate
    // ===========================
    /*
    if (IS_CORPORATE_SERVICE) {
      const baseValue = totals.valore;
      const productPrice = Number(delivery?.deliveryProducts?.[0]?.price) || 0;
      totals.totale = baseValue + productPrice;
    }
    */

    if (IS_CORPORATE_SERVICE) {
      const baseValue = totals.valore;
      const productPrice = (delivery.deliveryProducts || []).reduce((sum, item) => {
        return sum + (Number(item?.product?.price) || 0);
      }, 0);
      totals.totale = totals.fee + productPrice;
      totals.totale = Number(totals.valore) + Number(totals.valoreIva || 0);
    }

    return totals;
  }

}
